// extracted by mini-css-extract-plugin
export default {"formText":"customSearch_formText__aXI0r","CustomSearchBar":"customSearch_CustomSearchBar__nmggT","searchIcon":"customSearch_searchIcon__eIJnD"};